import TabToggle from 'components/commons/tab-toogle'
import { Button, InlineError, Input, Spinner, Switch } from 'avo-ui'
import UploadImage from 'components/commons/upload-image'
import Select from 'components/commons/select'

export const SpecialPromo = ({
    specialPromoDetail,
    optionsVoucher,
    errorForm,
    onChangeForm,
    onSearchVoucher,
    isLoading,
    isUpdating,
    isLoadingUpload,
    onSubmit,
}) => {
    return (
        <div className={'flex flex-col space-y-6'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'flex items-center justify-between border border-neutral-20 px-6 py-4 rounded-lg'}>
                        <p className={'font-semibold text-lg text-black-95'}>Special Promo</p>
                        <div className={'flex items-center space-x-6'}>
                            <p className={'font-semibold'}>{!specialPromoDetail?.is_show ? 'Hide' : 'Show'}</p>
                            <Switch name={'is_show'} checked={!!specialPromoDetail?.is_show} onChange={onChangeForm} />
                        </div>
                    </div>
                    <TabToggle
                        title={'General'}
                        content={
                            <div className={'flex space-x-16'}>
                                <div className={'flex-1 flex-col space-y-5'}>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90 required'}>Text Title</div>
                                        <Input
                                            className={'flex-1'}
                                            name={'title'}
                                            placeholder={'Masukkan text title'}
                                            value={specialPromoDetail?.special_promo?.title}
                                            onChange={onChangeForm}
                                        />
                                        <InlineError className='mt-2' message={errorForm?.special_promo?.title} />
                                    </div>
                                    <div
                                        className={`flex flex-col ${(specialPromoDetail?.special_promo?.title_image_url?.base64 || specialPromoDetail?.special_promo?.title_image_url) && 'space-y-3'}`}
                                    >
                                        <div className={'font-semibold text-blue-90'}>Image Title</div>
                                        <UploadImage
                                            className={'w-fit'}
                                            classNameImage={
                                                '!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'
                                            }
                                            id={'image-title'}
                                            value={
                                                specialPromoDetail?.special_promo?.title_image_url?.base64 ||
                                                specialPromoDetail?.special_promo?.title_image_url
                                            }
                                            onChange={(value) => onChangeForm({ name: 'title_image_url', value })}
                                        />
                                        <InlineError
                                            className='mt-2'
                                            message={errorForm?.special_promo?.title_image_url}
                                        />
                                    </div>
                                </div>
                                <div className={'flex-1 flex-col space-y-3'}>
                                    <div className={'font-semibold text-blue-90 required'}>Pilih Voucher</div>
                                    <Select
                                        name={'voucher_ids'}
                                        className={'flex-1'}
                                        optionsClassName={'max-h-40'}
                                        placeholder={'Pilih voucher'}
                                        options={optionsVoucher}
                                        value={specialPromoDetail?.special_promo?.voucher_ids}
                                        searchable
                                        isMultiple
                                        onChange={onChangeForm}
                                        onSearch={onSearchVoucher}
                                    />
                                    <InlineError className={'mt-2'} message={errorForm?.special_promo?.voucher_ids} />
                                </div>
                            </div>
                        }
                    />
                    <div className={'flex justify-end w-[calc(100%-544px)] py-3 bg-white fixed bottom-0 right-9 z-20'}>
                        <Button
                            className={'w-[200px] !bg-gradient-to-r !from-[#06308D] !to-[#3C6CD6] !border-neutral-20'}
                            loading={isLoadingUpload || isUpdating}
                            title={'SAVE ALL CHANGES'}
                            onClick={onSubmit}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
